<template>
  <div>
    <Card>
      <ui-icon :color="$colors.sunglow" icon="fas fa-star"></ui-icon>
    </Card>
    <Card>
      <ui-icon :color="$colors.sunglow" icon="fas fa-star" :disabled="true"></ui-icon>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { useColors } from '@/composables';

const $colors = useColors();
</script>
